import React, { useEffect, useState, useContext } from 'react';
import Navbar from '../Layout/Navbar/Navbar';
import Footer from '../Layout/Footer/Footer';
import Thumbnail from '../UI/Thumbnail';
import { FilterContext } from '../../context/FilterContext';
import { useParams, Link, useLocation } from 'react-router-dom';
const importAll = (require) =>
  require.keys().reduce((acc, next) => {
    acc[next.replace('./', '')] = require(next);
    return acc;
  }, {});
function Producto() {
  let { id } = useParams();
  const { state } = useContext(FilterContext);
  const [prod, setProd] = useState(null);
  const [imagesForProduct, setImagesForProduct] = useState([]);
  const [selectedImage, setSelectedImage] = useState('');
  const imgs = importAll(
    require.context('../../assets/images/productos', true),
  );

  useEffect(() => {
    if (!id) {
    } else {
      const pr = state.productos.filter((p) => p.codigo == id)[0];
      setProd(pr);
    }
  }, [id, JSON.stringify(state.productos)]);
  useEffect(() => {
    const imagenes = Object.keys(imgs)
      .map((im) => {
        if (im.split('/')[0] === prod?.codigo) {
          return imgs[im];
        } else {
          return null;
        }
      })
      .filter((s) => s);
    setImagesForProduct(imagenes);
    setSelectedImage(imagenes[0]);
  }, [prod, JSON.stringify(imgs)]);
  return (
    <div>
      <Navbar checkScroll={false} />

      <div className="min-h-full relative md:top-48 top-24 pb-24 md:pb-48 w-5/6 m-auto">
        {prod && (
          <div className="w-full pb-12 flex flex-wrap justify-between">
            <div className="pb-6 basis-full">
              <p className="text-gray-500 font-light">
                <Link to={'/'}>Home</Link> >{' '}
                <Link to={'/productos'}>Productos</Link> > {prod.codigo}
              </p>
            </div>
            <div className="basis-full md:basis-1/2 gap-1 flex">
              <div className="basis-1/6 flex flex-col gap-1 justify-start">
                {imagesForProduct.map((im) => {
                  return (
                    <Thumbnail
                      className="cursor-pointer"
                      onClick={() => setSelectedImage(im)}
                      src={im}
                    />
                  );
                })}
              </div>
              <img className="basis-5/6 w-3/4" src={selectedImage} />
            </div>
            <div className="basis-full md:basis-2/5 md:text-left text-right md:pt-0 pt-6">
              <h2 className="text-2xl md:text-4xl font-bold">{prod.codigo}</h2>
              <h3 className="font-light text-xl">{prod.nombre}</h3>
              <div className="pt-6 flex  flex-col gap-2 text-lg">
                <p>
                  <span className="font-bold">Ancho:</span> {prod.ancho}cm
                </p>
                <p>
                  <span className="font-bold">Alto:</span> {prod.alto}cm
                </p>
                <p>
                  <span className="font-bold">Profundidad:</span>{' '}
                  {prod.profundidad}cm
                </p>
                <p>
                  <span className="font-bold">Zocalo:</span>{' '}
                  {prod.nombre_zocalo}
                </p>
                <p>
                  <span className="font-bold">Ambiente:</span>{' '}
                  {prod.nombre_ambiente}
                </p>
                <p>
                  <span className="font-bold">Aplicacion:</span>{' '}
                  {prod.nombre_aplicacion}
                </p>
                <div className="flex md:justify-start justify-end gap-2 flex-wrap">
                  <p className="basis-full font-bold">Colores disponibles:</p>
                  {prod.colores.map((color) => {
                    const bg = 'bg-[' + color.codigo + ']';
                    return (
                      <div
                        className={`w-8 h-8 rounded-full border border-solid border-black ${
                          color.codigo === '#FFFFFF' ? 'bg-black' : 'bg-white'
                        }`}
                      ></div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
export default Producto;
